import { set, OxygenProvider } from '@8x8/oxygen-config'
import themes from '@8x8/oxygen-theme'
import React, { useEffect } from 'react'
import { Provider, useSelector } from 'react-redux'
import { THEMES } from '~/core/constants'

import store from '~/core/store'
import { getAppliedTheme } from '~/selectors/ui'

function withStoreHoC (Component) {
  const withStore = props => (
    <Provider store={store}>
      <Component {...props} />
    </Provider>
  )

  return withStore
}

function withThemeAndStoreHoC (Component) {
  const withTheme = props => {
    const theme = useSelector(getAppliedTheme)

    useEffect(() => {
      if (theme._name === THEMES.LIGHT) {
        set(themes.light)
      } else {
        set(themes.dark)
      }
    }, [theme])

    return (
      <OxygenProvider theme={theme} themeName={theme._name}>
        <Component {...props} />
      </OxygenProvider>
    )
  }

  return withStoreHoC(withTheme)
}

export default withThemeAndStoreHoC
